export const DirectLineActivityType = {
    MESSAGE: 'message',
    TYPING: 'typing',
    EVENT: 'event',
    END_OF_CONVERSATION: 'endOfConversation'
} as const;

export const DirectLineRole = {
    BOT: 'bot',
    USER: 'user'
} as const;

export const SCOUT_AI_MESSAGES = {
    DOCK: 'scout-ai-dock',
    CLOSE: 'scout-ai-close'
} as const;

export type ScoutAiMessageType = typeof SCOUT_AI_MESSAGES[keyof typeof SCOUT_AI_MESSAGES];

export interface DirectLineActivity {
    id: string;
    type: string;
    timestamp: string;
    from: DirectLineFrom;
    text: string;
    attachments: DirectLineAttachment[];
    suggestedActions: DirectLineSuggestedActions | null;
    value: unknown;
    responseTimeSeconds?: number;
}

export interface DirectLineFrom {
    id: string;
    name: string;
    role: string;
}

export interface DirectLineAttachment {
    contentType: string;
    contentUrl: string;
    name: string;
    content: unknown;
}

export interface OAuthCardContent {
    buttons?: { value?: string }[];
    tokenExchangeResource?: { uri?: string };
}

export interface DirectLineSuggestedActions {
    actions: SuggestedAction[];
}

export interface SuggestedAction {
    type: string;
    title: string;
    value: string;
}

export interface DirectLineOutboundActivity {
    type: string;
    from: { id: string };
    text?: string;
    name?: string;
    value?: unknown;
}

export interface DirectLineConversationResponse {
    conversationId: string;
    token: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    expires_in: number;
    streamUrl: string;
}

export interface DirectLineTokenRefreshResponse {
    token: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    expires_in: number;
}

export interface DirectLineSessionData {
    token: string;
    conversationId: string;
    expiresIn: number;
    storedAt: number;
    watermark: string;
    activities: DirectLineActivity[];
    isWaitingForResponse?: boolean;
}
